import { getCookie, removeCookie, setCookie } from './cookies';

const DELETE_ACCOUNT_REQUESTED = 'isBlocking';

export const getCookieDeleteAccountRequested = () => getCookie(DELETE_ACCOUNT_REQUESTED);
export const setCookieDeleteAccountRequested = () => setCookie(DELETE_ACCOUNT_REQUESTED, 1, 30);
export const removeCookieDeleteAccountRequested = () => removeCookie(DELETE_ACCOUNT_REQUESTED);
